import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const useGetUserDetailQuery = (userId: number) => {
  const { getUserDetail } = useServicesContext();

  return useQuery({
    queryKey: ['GET_USER_DETAIL', userId],
    queryFn: () => getUserDetail(userId),
    enabled: Boolean(userId),
  });
};
